// extracted by mini-css-extract-plugin
export default {"title":"UserAddPage_title__Q2S9D"};